import type { VisitorEvents } from '@smartsupp/websocket-client-visitor'
import { derived, get, writable } from 'svelte/store'

import { closeDrawer } from '@/modules/drawers'
import { visitorClientProvider } from '@/modules/websocketClient'
import { debugWidget } from '@/utils/debug'

import { isChatClosed, isChatOpened, isChatServed } from '../chat'
import { eventEmitter } from '../events'
import { errorMessage } from '../flashMessages'
import { t } from '../translations'

const TRANSCRIPT_TIMEOUT = 5000
let transcriptTimeout: NodeJS.Timeout

export const transcriptProcessing = writable<boolean>(false)

export const getTranscript = async () => {
	if (get(transcriptProcessing)) return
	eventEmitter.on('transcriptPdf', onTranscriptPdf)
	transcriptProcessing.set(true)
	transcriptTimeout = setTimeout(() => {
		onTranscriptPdfResolve()
		triggerErrorMessage('timeouted')
	}, TRANSCRIPT_TIMEOUT)
	await visitorClientProvider.getClient().chatTranscriptPdf()
}

export const shouldGetTranscript = derived(
	[isChatOpened, isChatServed, isChatClosed],
	([$isChatOpened, $isChatServed, $isChatClosed]): boolean => {
		return $isChatOpened || $isChatServed || $isChatClosed
	},
)

const onTranscriptPdfResolve = () => {
	transcriptProcessing.set(false)
	eventEmitter.off('transcriptPdf', onTranscriptPdf)
}

const triggerErrorMessage = (reason: string) => {
	errorMessage(get(t)('form.submit.error'))
	debugWidget(`widget PDF transcript ${reason}`)
}

const onTranscriptPdf = ({ ok, url }: VisitorEvents.ChatTranscriptPdf) => {
	if (transcriptTimeout) clearTimeout(transcriptTimeout)
	if (ok && url) {
		closeDrawer()
		window.open(url, '_blank')
	} else {
		triggerErrorMessage('failed')
	}
	onTranscriptPdfResolve()
}
